import type { ReactNode } from 'react';
import { cn } from '@/lib/utils/cn';

const widthMap = {
  narrow: 'max-w-[640px]',
  medium: 'max-w-[960px]',
  wide: 'max-w-[1280px]',
  full: 'max-w-none',
  /** @deprecated alias of `narrow`; kept for backward compatibility. */
  form: 'max-w-[640px]',
} as const;

type ContainerWidth = keyof typeof widthMap;

interface PageContainerProps {
  width?: ContainerWidth;
  className?: string;
  children: ReactNode;
}

export function PageContainer({
  width = 'wide',
  className,
  children,
}: PageContainerProps) {
  return (
    <div
      className={cn(
        'mx-auto px-8 py-10 lg:px-12',
        widthMap[width],
        className,
      )}
    >
      {children}
    </div>
  );
}
